import { type Action, type AnyAction, combineReducers } from 'redux';

import type { AIAvatar, AIAvatarVoicePreset, AIVoice } from 'js/src/client';
import {
    aiVoicesSlice,
    setAIVoices,
} from 'js/src/data/ai-voices-and-avatars/ai-voices/ai-voices-slices';
import {
    setAIAvatars,
    setAIAvatarVoicePresets,
    setAIVoiceoverBatchComplete,
} from 'js/src/data/ai-voices-and-avatars/ai-voices-and-avatars-actions';
import StoreORM from 'js/src/data/store-orm';

export function aiVoices(
    state = StoreORM.newFromIdPrefix<AIVoice, string>('ai-voices').data,
    action: Action,
) {
    if (setAIVoices.match(action)) {
        const orm = new StoreORM<AIVoice, string>(state);
        orm.delete(orm.getAllIds());
        action.payload?.forEach((voice) => {
            orm.pushJSItem(voice, 'slug');
        });
        return orm.data;
    }
    return state;
}

export function aiAvatarVoicePresets(
    state = StoreORM.newFromIdPrefix<AIAvatarVoicePreset>('ai-avatar-voice-presets').data,
    action: Action,
) {
    if (setAIAvatarVoicePresets.match(action)) {
        const orm = new StoreORM<AIAvatarVoicePreset>(state);
        orm.delete(orm.getAllIds());
        action.payload?.forEach((preset) => orm.pushJSItem(preset, 'id'));
        return orm.data;
    }
    return state;
}

export function aiAvatars(
    state = StoreORM.newFromIdPrefix<AIAvatar>('ai-avatars').data,
    action: Action,
) {
    if (setAIAvatars.match(action)) {
        const orm = new StoreORM<AIAvatar>(state);
        orm.delete(orm.getAllIds());
        action.payload?.forEach((avatar) => orm.pushJSItem(avatar, 'id'));
        return orm.data;
    }
    return state;
}

export function aiVoiceoverBatchComplete(state = false, action: AnyAction) {
    if (setAIVoiceoverBatchComplete.match(action)) {
        return action.payload;
    }
    return state;
}

export const aiVoicesAndAvatars = combineReducers({
    aiVoices,
    aiVoices2: aiVoicesSlice.reducer,
    aiAvatarVoicePresets,
    aiAvatars,
    aiVoiceoverBatchComplete,
});

export type AiVoicesAndAvatarsState = ReturnType<typeof aiVoicesAndAvatars>;
